module.exports = __webpack_public_path__ + "img/intro_no.aaa660c0.svg";